import React from "react";
import classNames from "classnames";

import styles from "./Badge.module.scss";

interface Props {
  dataQA: string;
  value: number;
  theme?: "light" | "dark";
  color?: "green" | "orange" | "red" | "blue";
  minDisplayValue?: number;
  maxDisplayValue?: number;
  className?: string;
}

const Badge: React.FC<Props> = ({
  dataQA,
  value,
  theme = "light",
  color = "blue",
  minDisplayValue = 1,
  maxDisplayValue = 99,
  className,
}) => {
  const number = value > maxDisplayValue ? `${maxDisplayValue}+` : value;

  return value >= minDisplayValue ? (
    <div
      data-qa={dataQA}
      className={classNames(
        styles.container,
        styles[theme],
        styles[color],
        className,
      )}
    >
      <span>{number}</span>
    </div>
  ) : null;
};

export default Badge;
